import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SecretariaService from '../../services/secretaria'
import VeiculoService from '../../services/veiculos'
import Veiculo from './veiculo';
import '../../styles/lrf.scss';

const ListarVeiculos = () => {

    const [secretarias, setSecretarias] = useState([]);
    const [veiculos, setVeiculos] = useState([]);
    const [vazio, setVazio] = useState(false);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }


    async function fetchVeiculos() {
        await montaSec()
        const response = await VeiculoService.listar();
        if (response.data.length >= 1) {
            setVeiculos(response.data)
            setVazio(false)
        } else {
            setVeiculos([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchVeiculos();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setVeiculos={setVeiculos}
                    setVazio={setVazio}
                    fetchVeiculos={fetchVeiculos}
                    secretarias={secretarias}
                    veiculos={veiculos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h5 className='titulo-listas'>Frota Municipal</h5>
                    <Row xs={1} lg={3}>
                        {veiculos.map((veiculo, index) =>
                            <Veiculo
                                veiculo={veiculo}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarVeiculos;